// extracted by mini-css-extract-plugin
module.exports = {"width-limit":"index_width-limit__SFlgU","overflow-hidden":"index_overflow-hidden__7hcMk","dark":"index_dark__oCx5W","light":"index_light__fPqlf","popup":"index_popup__xrOBg"};